import React from 'react'
import {Problem} from 'data/types'
import {Col, Row} from './Display'
import _ from 'lodash'
import styleDetailArrow from 'assets/style-detail-arrow.svg'
import CalandarOff from '../assets/calandar-off.svg'
import i18n from 'i18n'
import Button from './Button'
import {useFunction} from 'utils/hooks/function'
import services from 'services'
import moment from 'moment'

type SuggestedSolutionProps = {
  suggestedSolution: any
  setSelectedSolution: () => void
  problem: Problem
}

export default function SuggestedSolution(props: SuggestedSolutionProps) {
  const problemSolutionService = services.getSingleProblemService(props.problem.id)
  const dismissSolution = useFunction(problemSolutionService.archiveSolution)

  const handleDismissClick = (event: any) => {
    event.stopPropagation()
    dismissSolution(props.suggestedSolution.id)
  }

  return (
    <Col
      key={props.suggestedSolution.id}
      className="border border-gray-300 rounded-md my-4 cursor-pointer"
      onClick={() => {
        props.setSelectedSolution()
      }}
    >
      <Row className="mx-2 pt-2 pb-4 justify-between">
        <Row className="text-sm font-semibold text-itx-greyscale-2">{_.truncate(props.suggestedSolution.title, {length: 70})}</Row>
        <Row className="items-center">
          <Row>
            <div className="flex text-itx-primary-4 text-xs font-semibold">{i18n.t('solutions.seeDetails')}</div>
          </Row>
          <Row>
            <img className="pl-2 w-full" alt="styleDetailArrow" src={styleDetailArrow} />
          </Row>
        </Row>
      </Row>

      <Row className="mx-2 pt-2 pb-2 justify-between items-center">
        <Row className="items-center">
          <Row className="items-center pl-2 pb-px">
            <img className="h-4 w-4 object-cover" src={CalandarOff} alt={'Calandar'} />
            <span className="ml-2 text-xs font-normal text-itx-greyscale-3">
              {moment(props.suggestedSolution.createdAt).startOf('minutes').fromNow()}
            </span>
          </Row>
        </Row>

        <Row className="items-center">
          <Row className="mr-2 text-sm font-normal text-itx-greyscale-3">Not relevant ?</Row>
          <Button
            onClick={(event: any) => handleDismissClick(event)}
            style={{fontWeight: 500, paddingLeft: '4px', paddingRight: '4px'}}
            type="smallCta"
            className="rounded border px-4 bg-white border-itx-greyscale-3 text-itx-greyscale-3 font-regular pt-0 items-baseline flex-shrink-0 hover:shadow-md transition duration-200 cursor-pointer"
            content={i18n.t('solutions.dismiss')}
          />
        </Row>
      </Row>
    </Col>
  )
}
